import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";
import { useLang } from "../../i18n";

const KEY = "voltpdr_cookie_consent";

export const CookieConsent = () => {
  const { lang } = useLang();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      if (!localStorage.getItem(KEY)) setShow(true);
    }, 900);
    return () => clearTimeout(t);
  }, []);

  const decide = (value) => {
    localStorage.setItem(KEY, value);
    setShow(false);
  };

  const t = {
    ro: {
      text: "Folosim cookie-uri pentru a asigura funcționarea site-ului și a îmbunătăți experiența ta.",
      more: "Află mai multe",
      accept: "Accept",
      reject: "Doar necesare",
    },
    en: {
      text: "We use cookies to ensure the site works and to improve your experience.",
      more: "Learn more",
      accept: "Accept",
      reject: "Essential only",
    },
  }[lang];

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 40 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 left-4 right-4 z-[60] mx-auto max-w-2xl rounded-2xl border border-white/12 bg-ink/90 p-5 shadow-2xl backdrop-blur-md md:left-6 md:right-auto md:bottom-6"
          data-testid="cookie-consent"
        >
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
            <div className="flex items-start gap-3">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-glow-2/25 bg-glow-2/10 text-glow-2">
                <Cookie className="h-5 w-5" />
              </div>
              <p className="text-sm leading-relaxed text-white/70">
                {t.text}{" "}
                <Link to="/cookies" className="text-glow-2 underline-offset-2 hover:underline" data-testid="cookie-more-link">
                  {t.more}
                </Link>
              </p>
            </div>
            <div className="flex shrink-0 gap-2">
              <button
                onClick={() => decide("essential")}
                data-testid="cookie-reject"
                className="rounded-full border border-white/15 px-4 py-2.5 text-sm font-medium text-white/80 transition-colors hover:border-white/30 hover:text-white"
              >
                {t.reject}
              </button>
              <button
                onClick={() => decide("all")}
                data-testid="cookie-accept"
                className="btn-glow rounded-full bg-brand px-5 py-2.5 text-sm font-semibold text-ink glow-ring"
              >
                {t.accept}
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
